module.exports = __webpack_public_path__ + "img/produkt-petrzel.157ce694.jpg";